/**
 * Ce que l'écran dit après une inscription par l'administration.
 *
 * Sorti de la page « Inscription admin » pour que la liste d'attente, qui
 * inscrit par le même chemin (`create_order`, puis la facture envoyée), dise
 * exactement la même chose : le montant facturé, les codes et la provision
 * appliqués, le reste à payer, et si le courriel est parti.
 */
import { euros, type Commande } from './devis';
import type { EnvoiDeFacture } from './facture';

export interface ResultatInscription {
  type: 'success' | 'error';
  message: string;
}

export function resultatInscriptionAdmin(
  invoiceNumber: string,
  commande: Pick<Commande, 'amount_cents' | 'gratuity_cents' | 'provision_applied_cents' | 'remaining_cents'>,
  envoi: Pick<EnvoiDeFacture, 'erreur'>,
  courriel: string,
): ResultatInscription {
  const detail = [
    `Facture ${invoiceNumber} créée pour ${euros(commande.amount_cents)}.`,
    commande.gratuity_cents > 0
      ? `Codes cadeaux : −${euros(commande.gratuity_cents)}.` : null,
    commande.provision_applied_cents > 0
      ? `Provision appliquée : ${euros(commande.provision_applied_cents)}.` : null,
    `Reste à payer : ${euros(commande.remaining_cents)}.`,
    envoi.erreur
      ? `⚠ La facture n'a pas pu être envoyée : ${envoi.erreur}\nL'inscription est bien enregistrée ; le document se produit depuis « Paiements ».`
      : `Facture envoyée à ${courriel}.`,
  ].filter(Boolean).join('\n');

  return {
    type: envoi.erreur ? 'error' : 'success',
    message: envoi.erreur
      ? `Inscription confirmée, mais la facture n'est pas partie.\n\n${detail}`
      : `Inscription confirmée avec succès !\n\n${detail}`,
  };
}
